export default __webpack_public_path__ + "static/media/PhilipBlue.c2c48306.jpg";